
import * as XLSX from 'xlsx'
export const ExportTable = (matrixExport, origem:any = '', nomeSaida='dados.xlsx' ) => {
    const worksheet = XLSX.utils.json_to_sheet(matrixExport,origem )
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, worksheet, 'Tabela de Dados')
    console.log(nomeSaida)
    XLSX.writeFile(wb, nomeSaida)
}
